import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSendRepliesOutsideOrgEnabledState', function setSendRepliesOutsideOrgEnabledState(choice) {
    var optionState = getStore().currentState;
    optionState.sendRepliesOutsideOrgEnabled = choice;
    if (!choice) {
        optionState.sendRepliesToContactsOnlyEnabled = choice;
    }
});
//# sourceMappingURL=setSendRepliesOutsideOrgEnabledState.js.map